import {
  computed,
  useContext,
  useRoute
} from "@nuxtjs/composition-api";
import { useCategoryStore } from "../stores/category";
import { findActiveCategory } from "../helpers/findActiveCategory";
import { findCategoryAncestors } from "../helpers/findCategoryAncestors";
function useTraverseCategory() {
  const context = useContext();
  const categoryStore = useCategoryStore();
  const route = useRoute();
  const categoryTree = computed(() => categoryStore.categories);
  const isCategoryTreeLoaded = computed(() => categoryStore.categories !== null);
  const loadCategoryTree = () => categoryStore.load();
  const activeCategory = computed(() => {
    const urlPathToFind = route.value.path.replace(context.app.localePath("/"), "").replace(/^\//, "").replace(".html", "");
    return categoryTree.value === null ? null : findActiveCategory(categoryTree.value, urlPathToFind);
  });
  const categoryAncestors = computed(() => {
    var _a;
    return (_a = activeCategory.value === null ? [] : findCategoryAncestors(categoryTree.value, activeCategory.value)) != null ? _a : [];
  });
  return {
    activeCategory,
    categoryAncestors,
    categoryTree,
    loadCategoryTree,
    isCategoryTreeLoaded
  };
}
export {
  useTraverseCategory
};
